export type DisplayMode =
  | "window-controls-overlay"
  | "fullscreen"
  | "standalone"
  | "minimal-ui"
  | "browser"

// Most specific first: an installed app with window controls overlay also
// matches `standalone` in some browsers.
const APP_DISPLAY_MODES: Exclude<DisplayMode, "browser">[] = [
  "window-controls-overlay",
  "fullscreen",
  "standalone",
  "minimal-ui",
]

let queries: Map<DisplayMode, MediaQueryList> | null = null

const getQueries = (): Map<DisplayMode, MediaQueryList> => {
  if (queries) return queries
  queries = new Map()
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return queries
  }
  for (const mode of APP_DISPLAY_MODES) {
    try {
      queries.set(mode, window.matchMedia(`(display-mode: ${mode})`))
    } catch {
      // ignore: an old engine that does not know the feature
    }
  }
  return queries
}

/**
 * How the page is displayed: `standalone` (or another app mode) when running
 * as the installed PWA, `browser` for a plain tab. Lets analytics tell whether
 * a badge or notification report comes from the installed app.
 */
export const getDisplayMode = (): DisplayMode => {
  for (const mode of APP_DISPLAY_MODES) {
    if (getQueries().get(mode)?.matches) return mode
  }
  return "browser"
}

export const __resetDisplayModeForTests = (): void => {
  queries = null
}
